import { tokens } from '@cast/design-system';

import { MetricsProgressCard } from '../_components/MetricsProgressCard';
import { useReliabilityDashboardData } from './_hooks/useReliabilityDashboardData';

const HEALTH_METRICS = [
  { key: 'healthy', label: 'Healthy', color: tokens.theme.data.green500 },
  { key: 'warning', label: 'Degraded', color: tokens.theme.data.yellow500 },
  { key: 'breach', label: 'Unhealthy', color: tokens.theme.data.red500 },
] as const;

export const WorkloadHealthTrafficShareCard = () => {
  const { trafficByHealth, isLoading, isFetching, error, refetch } =
    useReliabilityDashboardData();

  return (
    <MetricsProgressCard
      title="Traffic distribution per workload health"
      testId="workload-health-traffic-share-card"
      metrics={HEALTH_METRICS.map(({ key, label, color }) => ({
        label,
        value: trafficByHealth[key].percent,
        unit: `${trafficByHealth[key].reqPerSec.toLocaleString()} REQ/S`,
        color,
        testId: `workload-health-traffic-${key}`,
      }))}
      isLoading={isLoading}
      isFetching={isFetching}
      error={error}
      refresh={refetch}
    />
  );
};
